<template>
  <vs-prompt
    @accept="save"
    @cancel="cancel"
    @close="close"
    :active.sync="showDialog"
    :title="title"
    :accept-text="acceptText"
    :cancel-text="cancelText"
    :is-valid="isValid"
  >
    <vs-progress
      v-show="showProgress"
      indeterminate
      color="primary"
    ></vs-progress>

    <div class="content">
      <section class="cropper-area">
        <div class="img-cropper">
          <div
            v-if="!imgSrc"
            :class="[isDrag ? dragoverClass : dragleaveClass]"
            @dragover.prevent="checkDrag($event, true)"
            @dragleave.prevent="checkDrag($event, false)"
            @drop.prevent="setImage($event)"
            @click="$refs.update_photo_input.click()"
          >
            <input
              type="file"
              ref="update_photo_input"
              class="hidden"
              @change="setImage($event)"
            />
            <span
              >画像ファイルをドロップ、<br />またはクリックしてファイルを選択</span
            >
          </div>

          <vue-cropper
            v-if="isCrop"
            ref="cropper"
            :src="imgSrc"
            :aspect-ratio="16 / 9"
            preview=".preview"
          ></vue-cropper>
        </div>
      </section>
      <section v-if="isCrop" class="preview-area ml-4">
        <small>プレビュー</small>
        <div class="preview" />
      </section>
    </div>
    <section v-if="isCrop" class="actions">
      <vs-button color="primary" type="line" @click="rotate(90)"
        >時計回りに回転</vs-button
      >
      <vs-button color="primary" type="line" @click="rotate(-90)"
        >反時計回りに回転</vs-button
      >
    </section>
  </vs-prompt>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import { FileUtil } from "@/utils";

const { mapActions } = createNamespacedHelpers("enterpriseVesselEdit");

export default {
  components: { VueCropper },
  data() {
    return {
      showDialog: false,
      title: "船舶画像の選択",
      acceptText: "追加",
      cancelText: "キャンセル",
      pictureData: {},
      pictureUrl: null,
      imgSrc: null,
      fileType: null,
      cropImg: null,
      isDrag: false,
      isCrop: null,
      dragleaveClass: "drag-area-dragleave",
      dragoverClass: "drag-area-dragover"
    };
  },
  methods: {
    ...mapActions(["fetchGallery", "addPicture"]),

    show() {
      this.showDialog = true;
    },

    save() {
      this.isCrop = false;
      let base64 = this.$refs.cropper.getCroppedCanvas().toDataURL();
      this.uploadImage(FileUtil.toBlob(base64, this.fileType));
    },

    close() {
      this.cleanUp();
    },

    cancel() {
      this.cleanUp();
    },

    checkDrag(e, isDrag) {
      this.isDrag = isDrag;
    },

    setImage(e) {
      this.title = "船舶画像のトリミング";
      const file =
        typeof e.target.files !== "undefined"
          ? e.target.files[0]
          : e.dataTransfer.files[0];

      if (file.type.indexOf("image/") === -1) {
        return;
      }
      this.fileType = file.type;
      let reader = new FileReader();
      reader.onload = e => {
        this.imgSrc = e.target.result;
        this.isValid = true;
        this.isCrop = true;
      };
      reader.readAsDataURL(file);
    },

    async uploadImage(inputFile) {
      this.$vs.loading();
      let payload = { vesselId: this.$route.params.vesselId, file: inputFile };
      try {
        await this.addPicture(payload);
        this.$vs.loading.close();
        this.cleanUp();
        this.$vs.notify({
          title: "新しい写真を追加しました",
          color: "success",
          iconPack: "feather",
          icon: "icon-check"
        });
      } catch (e) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "写真の登録に失敗しました",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
        this.close();
      }
    },

    rotate(deg) {
      this.$refs.cropper.rotate(deg);
    },

    cleanUp() {
      this.showDialog = false;
      this.imgSrc = null;
      this.isCrop = false;
      this.isDrag = false;
      this.isValid = false;
      this.title = "船舶画像の選択";
    }
  }
};
</script>

<style lang="scss">
#dialog-upload-vessel-picture {
  .drag-area-dragleave {
    width: 100%;
    min-width: 200px;
    height: 100%;
    min-height: 200px;
    border: 2px dotted rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-color: #f5f5f5;
    text-align: center;
  }

  .drag-area-dragover {
    width: 100%;
    min-width: 200px;
    height: 100%;
    min-height: 200px;
    border: 2px solid rgba(115, 103, 240, 1);
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-color: #f5f5f5;
    text-align: center;
  }

  .vs-dialog {
    max-width: 550px;
  }

  .content {
    display: flex;
    justify-content: space-between;
  }

  .cropper-area {
    width: 614px;
  }

  .preview-area {
    width: 307px;
  }
  .preview-area p {
    font-size: 1.25rem;
    margin: 0rem 0rem 1rem;
  }
  .preview-area p:last-of-type {
    margin-top: 0rem;
  }
  .preview {
    width: 100%;
    height: calc(372px * (9 / 16));
    overflow: hidden;
  }
  .actions {
    margin-top: 1rem;
  }
  .actions button {
    padding: 5px 15px;
    margin-right: 1rem;
    margin-bottom: 1rem;
  }
  .crop-placeholder {
    width: 100%;
    height: 200px;
    background: #ccc;
  }
  .cropped-image img {
    max-width: 100%;
  }
}
</style>
